import { apiFetch } from '../utils/api';

export interface AutomaticPromotionTier {
  minimum_spend_amount?: number;
  flat_amount?: number;
  percentage?: number;
}

export interface AutomaticPromotionLocation {
  id: number;
  name: string;
}

export interface AutomaticPromotion {
  id: string;
  erpId: number;
  name: string;
  status: number | null;
  promotionType: string | null;
  promotionTypeKey: string | null;
  timeframeType: string | null;
  percentage: number | null;
  flatAmount: number | null;
  promotionTiers: AutomaticPromotionTier[] | null;
  startDate: string | null;
  endDate: string | null;
  startTime: string | null;
  endTime: string | null;
  allowWalkInMember: boolean;
  allowRegisteredMember: boolean;
  allowEmployee: boolean;
  isAutomatic: boolean;
  isAvailableInPos: boolean;
  dreamPriceApplicable: boolean;
  isMembershipRequired: boolean;
  locations: AutomaticPromotionLocation[] | null;
  updatedAt: string;
}

export interface PaginatedAutomaticPromotionsResponse {
  data: AutomaticPromotion[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface FetchAutomaticPromotionsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const fetchAutomaticPromotions = (
  params: FetchAutomaticPromotionsParams = {},
): Promise<PaginatedAutomaticPromotionsResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedAutomaticPromotionsResponse>(
    `/automatic-promotions${query ? `?${query}` : ''}`,
  );
};

export const fetchAutomaticPromotion = (id: string) =>
  apiFetch<AutomaticPromotion>(`/automatic-promotions/${id}`);
